<template>
  <div class="pagination" v-if="pageCount > 1">
    <span
      :class="pageIndex <= 0 ? 'current prev' : 'prev'"
      rel="prev"
      @click="go(pageIndex - 1)"
    >上页</span>
    <template v-for="(p, i) in buttons">
      <span v-if="p === '...'" :key="'e' + i">...</span>
      <span v-else-if="p === pageIndex" :key="'c' + p" class="current">{{ p + 1 }}</span>
      <a
        v-else
        :key="'a' + p"
        href="javascript:void(0);"
        @click.prevent="go(p)"
      >{{ p + 1 }}</a>
    </template>
    <a
      v-if="pageIndex < pageCount - 1"
      href="javascript:void(0);"
      class="next"
      rel="next"
      @click.prevent="go(pageIndex + 1)"
    >下页</a>
    <span v-else class="current next" rel="next">下页</span>
  </div>
</template>

<script>
export default {
  name: 'IvanPager',
  props: {
    pageIndex: { type: Number, default: 0 },
    pageCount: { type: Number, default: 1 }
  },
  computed: {
    buttons() {
      const total = this.pageCount
      const cur = this.pageIndex
      if (total <= 7) return Array.from({ length: total }, (_, i) => i)
      const set = new Set([0, total - 1, cur])
      for (let i = cur - 1; i <= cur + 1; i++) {
        if (i > 0 && i < total - 1) set.add(i)
      }
      const sorted = Array.from(set).sort((a, b) => a - b)
      const out = []
      let prev = null
      sorted.forEach(p => {
        if (prev != null && p - prev > 1) out.push('...')
        out.push(p)
        prev = p
      })
      return out
    }
  },
  methods: {
    go(idx) {
      if (idx < 0 || idx >= this.pageCount) return
      this.$emit('update:pageIndex', idx)
      this.$emit('change', idx)
    }
  }
}
</script>
